import InstaBlock from '../../../components/molecules/instaBlock';
import YotpoWidget from '../../../components/atoms/yotpo';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React from 'react';

const InstaSectionTastic = ({ data, context }) => {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  return (
    <>
      <YotpoWidget />
      <InstaBlock {...data} />
    </>
  );
};

export default tastify({ translate: true, connect: { context: true } })(
  InstaSectionTastic,
);
